module.exports = __webpack_public_path__ + "static/3_SUPERSINGLE-79c623422754c336571c68caefd2db1f.png";